import React from "react";

import { IQuestion } from "pages/homework";
import QuestionItem from "pages/homework/component/questionItem";

interface IProps {
    homeworkState: number;
    topics: IQuestion[];
    onQuestionChange: (
        topicId: number,
        topicType: string,
        answerId: number | number[],
        value?: string,
        userAnswers?: any
    ) => void;
}

export const Cloze = ({ topics, homeworkState, onQuestionChange }: IProps) => {
    return (
        <>
            {topics.map((topic, index) => (
                <QuestionItem
                    item={topic}
                    canPastedText={false}
                    key={index}
                    topicId={topic.topicId}
                    topicType={topic.topicType}
                    trunk={topic.trunk}
                    answers={topic.answers}
                    homeworkState={homeworkState}
                    onQuestionChange={onQuestionChange}
                    contentText={topic.contentText}
                />
            ))}
        </>
    );
};
